import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import SideMenuList from './SideMenyList'
import Header from '../components/version-4/Header'
import Sidebar from '../components/version-4/Sidebar'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100vh',
    width: '100vw',
    flexDirection: 'column',
  },
  navBar: {
    height: '120px',
    width: 'calc(100vw-235px)',

    marginLeft: '234px',
    transition: theme.transitions.create(['width', 'marginLeft'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  sideBar: {
    width: '380px',
    overflowY: 'scroll',
    padding: '15px',
    height: 'calc(100%)',
    background: '#F6F8FE',
    border: '1px solid #E0E4F1',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  contentContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    background: 'white',

    // height: 'calc(100vh - 120px)',
  },
  infoContent1: {
    // height: 'calc(100vh - 120px)',
    // height: '100vh',
    //overflowY: 'scroll',
    width: 'calc(100vw - 233px)',
    backgroundColor: 'white',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  infoContent2: {
    // height: 'calc(100vh - 100px)',
    // overflowY: 'scroll',
    width: 'calc(100vw - 73px)',
    backgroundColor: 'white',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  collapsed: {
    marginLeft: 0,
  },
}))

function HeaderWithSideBar(props) {
  const { children, heading, selectedDate, setSelectedDate, searchQuery, setSearchQuery, GridAttend } = props
  const { open, handleOpen } = props
  const classes = useStyles()

  return (
    <Grid>
      <Grid item className={open ? classes.navBar : `${classes.navBar} ${classes.collapsed}`}>
        <Header open={open} searchQuery={searchQuery} setSearchQuery={setSearchQuery} GridAttend={GridAttend} />
      </Grid>

      <div className={classes.contentContainer}>
        <div>
          <Sidebar open={open} handleOpen={handleOpen} />
        </div>
        <div className={open ? classes.infoContent1 : classes.infoContent2}>{children}</div>
      </div>
    </Grid>
  )
}

export default HeaderWithSideBar
